import { cva, type VariantProps } from 'class-variance-authority';
import { SearchMode } from '@pkgs/components/hooks/stores/search/slices/searchModeSlice';

import { Visibility } from '../Visibility/Visibility';
import { MobileLocationFilter } from '../LocationFilter/MobileLocationFilter';
import { DesktopLocationFilter } from '../LocationFilter/DesktopLocationFilter';

import styles from './LocationFilter.module.css';

const desktopVisibilityVariants = cva(styles.baseClass, {
  variants: {
    searchMode: {
      [SearchMode.CLASSIC]: null,
      [SearchMode.AI]: styles.ai,
    },
  },
});

type LocationFilterProps = {
  searchMode: NonNullable<VariantProps<typeof desktopVisibilityVariants>['searchMode']>;
};

export const LocationFilter = ({ searchMode }: LocationFilterProps) => {
  return (
    <>
      <Visibility visibleFrom="tabletLandscape" className={desktopVisibilityVariants({ searchMode })}>
        <DesktopLocationFilter />
      </Visibility>
      <Visibility visibleTo="tabletLandscape" className={styles.mobileVisibility}>
        <MobileLocationFilter />
      </Visibility>
    </>
  );
};
